export const isVisible = (element) => {
  if (!element) return false;

  const { display, visibility, opacity } = getComputedStyle(element);
  if (display === "none" || visibility === "hidden" || opacity === "0") return false;

  const hasSize = element.offsetWidth > 0 && element.offsetHeight > 0;
  const hasRect = element.getClientRects().length > 0;

  return hasSize && hasRect;
};

export const pollUntil = ({ check, interval = 200, maxAttempts = 50, onGiveUp }) => {
  let attempts = 0;
  const id = setInterval(() => {
    attempts += 1;
    try {
      if (check()) {
        clearInterval(id);
      } else if (attempts >= maxAttempts) {
        clearInterval(id);
        if (onGiveUp) onGiveUp();
      }
    } catch (err) {
      clearInterval(id);
      try {
        if (onGiveUp) onGiveUp();
      } finally {
        console.error("pollUntil: check() threw", {
          checkName: check.name || "(anonymous)",
          err,
          interval,
          maxAttempts,
          attempts,
        });
      }
    }
  }, interval);
  return () => clearInterval(id);
};

export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
};

export const setCookie = (name, value, days = 365) => {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};path=/`;
};
